import LookUpModel from "./LookUpModel";

export default class ProdottiModel extends LookUpModel {
    constructor(data: Partial<ProdottiModel>) {
        super(data);

        this.update(data);
    }
}
